// Signifyd's documented device-profiling script contract.
// developer.signifyd.com/main/reference/device-profiling
export const SIGNIFYD_SCRIPT_ID = 'sig-api';
export const SIGNIFYD_SCRIPT_SRC = 'https://cdn-scripts.signifyd.com/api/script-tag.js';

// Signifyd dispatches this event on `document` when its script fails to initialize.
export const SIGNIFYD_ERROR_EVENT = 'sigScriptError';

// Payment-session id: one UUID v4 per checkout, reused for the Signifyd script's
// `data-order-session-id` and `payment_context.payment_session_id`.
export const PAYMENT_SESSION_STORAGE_KEY = 'payment-session-id';
export const PAYMENT_SESSION_TTL_MS = 60 * 60 * 1000; // 1 hour
